import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Spinner from "../../Spinner";

/* props: defaultText, text, key, handleChange, parentKey, focusKey, changeOpts, dataReady */
const DraftEditor = (props) => {
  /**
   * extract the user input from the wysiwyg editor and
   * construct a new event object to pass to the parent
   * onchange handler.
   **/
  let handleChange = (opts, e) => {
    const html = draftToHtml(convertToRaw(e.getCurrentContent()));
    let event = {
      target: {
        value: html,
      },
    };
    props.handleChange(opts, event);
  };

  const defaultText = props.defaultText || "";
  let initContent;

  try {
    /* NOTE: using the html-to-draftjs module here because it is designed to work with
     *       react-draft-wysiwyg. The native draft-js conversion method has issues with
     *       images, subscripts, etc...
     */
    let blocksFromHTML = htmlToDraft(props.text);
    /**
     * NOTE: We have to get the raw content state from the EditorState, because
     *       the ContentState created from the blocks array is missing some
     *       variable definitions expected by the Editor that are given default values
     *       by EditorState.createWithContent(). This might be something we can also solve
     *       by configuring the editor differently, but for now, this works.
     **/
    initContent = convertToRaw(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        )
      ).getCurrentContent()
    );
  } catch (e) {
    initContent = props.text;
  }

  const editor =
    props.focusKey === props.parentKey ? (
      <Editor
        wrapperId={props.parentKey + "input"}
        wrapperClassName="col-10 dark-border"
        onEditorStateChange={(e) => handleChange(props.changeOpts, e)}
        initialContentState={initContent}
        readOnly={false}
        placeholder={defaultText}
      />
    ) : (
      <Editor
        wrapperId={props.parentKey + "input"}
        wrapperClassName="col-12"
        toolbarHidden={true}
        readOnly={true}
        contentState={initContent}
        placeholder={defaultText}
      />
    );

  // const spinner = (<div className='spinner'></div>);

  return props.dataReady ? editor : <Spinner />;
};

const propsAreEqual = (prevProps, nextProps) => {
  const wasInFocus = prevProps.focusKey === prevProps.parentKey;
  const isInFocus = nextProps.focusKey === nextProps.parentKey;
  return (
    prevProps.text === nextProps.text &&
    // && prevProps.handleChange === nextProps.handleChange
    prevProps.changeOpts === nextProps.changeOpts &&
    prevProps.dataReady === nextProps.dataReady &&
    wasInFocus === isInFocus
  );
};

const DrEditor = React.memo(DraftEditor, propsAreEqual);
export default DrEditor;
